var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Test",
    "data-name": "Icon / Test",
    transform: "translate(-1969 -1518.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    transform: "translate(1969 1518.527)",
    fill: "#fff",
    stroke: "#008d9c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "T",
    transform: "translate(1976 1536.528)",
    fill: "#008d9c",
    fontSize: 15,
    fontFamily: "",
    fontWeight: 700,
    letterSpacing: "0.009em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.5,
    y: 0
  }, "T")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/testIcon.ee0f920e44147c1cdce7a2860ba48bc5.svg";
export { ForwardRef as ReactComponent };